import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api/client';

export interface PendingTemplate {
  name: string;
  category?: string;
  language?: string;
  components?: Array<{
    type: string;
    text?: string;
    buttons?: Array<{ type: string; text: string; url?: string }>;
  }>;
}

export interface PendingFlow {
  name?: string;
  description?: string;
  nodes?: any[];
  edges?: any[];
  created_at?: string;
  trigger_type?: string;
  triggerType?: string;
  trigger_keywords?: string[];
  trigger_config?: {
    keywords?: string[];
  };
  trigger?: {
    type?: string;
    keywords?: string[];
  };
}

interface PendingOnboardingAssets {
  pending_templates: PendingTemplate[];
  pending_flow: PendingFlow | null;
  activated_business_account_id?: string | null;
  activated_at?: string | null;
}

export function usePendingOnboardingAssets() {
  return useQuery<PendingOnboardingAssets>({
    queryKey: ['onboarding-pending-assets'],
    queryFn: async () => {
      const res = await apiClient.get('/onboarding/qa');
      const data = res.data?.data || res.data || {};
      return {
        pending_templates: Array.isArray(data.pending_templates) ? data.pending_templates : [],
        pending_flow: data.pending_flow ?? null,
        activated_business_account_id: data.activated_business_account_id ?? null,
        activated_at: data.activated_at ?? null,
      };
    },
    // This hook is mounted in FeatureRoute + RoleRoute (which wrap nearly every
    // route) plus Dashboard / Flows / the template library, so it runs on almost
    // every navigation. Onboarding pending-assets change only during the one-time
    // onboarding flow, so a 5-minute stale window lets rapid navigation reuse the
    // cached result instead of re-hitting /onboarding/qa on every route change
    // (36 calls in one HAR). Was staleTime:0 + refetchOnMount:true (refetch on
    // every mount). refetchOnMount stays true so a mount after the window still
    // revalidates; nothing invalidates this key, so the window IS the refresh.
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
